/**
 * WbFactRow — rij van 2 tot 3 feitenvakken.
 *
 * Label klein bovenop, waarde mono groot. Voor feiten die altijd zichtbaar
 * horen te zijn (maat, pakket, order, bedrag). Een vak mag een invoerveld
 * bevatten via `children` in plaats van `value`.
 */

import clsx from 'clsx';

export interface WbFact {
  label: string;
  value?: React.ReactNode;
  children?: React.ReactNode;
  /** Vak zonder mono (bv. pakketnaam). */
  tekst?: boolean;
}

export interface WbFactRowProps {
  facts: WbFact[];
  className?: string;
}

export function WbFactRow({ facts, className }: WbFactRowProps) {
  return (
    <div className={clsx('grid gap-2', className)} style={{ gridTemplateColumns: `repeat(${Math.min(facts.length, 3)}, minmax(0, 1fr))` }}>
      {facts.map((f, i) => (
        <div key={i} className="min-h-tap bg-wb-vlak border-wb border-wb-rand rounded-wb px-3 py-1.5 flex flex-col justify-center min-w-0">
          <p className="text-[11px] font-bold uppercase tracking-wide text-wb-inkt2 leading-tight">{f.label}</p>
          {f.children ?? (
            <p className={clsx('text-wb-inkt leading-tight truncate', f.tekst ? 'text-base font-semibold' : 'font-mono text-lg font-semibold')}>
              {f.value ?? '–'}
            </p>
          )}
        </div>
      ))}
    </div>
  );
}
